import { GroupStandards } from '@/models/progress-report/progress-report';
import { formatTime } from '@/utils/date';
import { getGradeRange } from '@/utils/utils';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    name: 'cp-content-card',
    components: {

    },
})

export default class CPContentCard extends Vue {

    // -----------------------------------------------------------------
    // Properties
    @Prop()
    private content!: GroupStandards;

    @Prop()
    private sequece: any;

    private get competencies() {
        return this.content.competencies || [];
    }

    // --------------------------------------------------------------------
    // Actions

    private onSelectContent(collection: any) {
        this.$emit('onSelectContent', collection);
    }

    // -------------------------------------------------------------------
    // Methods

    private getGradeRange(value: number) {
        return getGradeRange(value);
    }

    private formatTime(value: number) {
        return formatTime(value);
    }

}
